module.exports = __webpack_public_path__ + "img/quality-yellow.30537519.png";